module.exports = __webpack_public_path__ + "img/project1.7c8d2050.jpg";